import {
  ORDER_DETAIL,
  COUNTRY_COMPARISON,
  BUYER_COMMENTS,
  ITEM_DEMAND_SUMMARY,
  RETURNED_PRODUCTS,
  BATCH_DETAIL,
  SHIPMENTS_SHIPPED_ITEMS,
  RAW_EXPORTS_CUSTOMERS,
  RAW_EXPORTS_ORDERS,
  RAW_EXPORTS_SHIPPED_ORDERS,
  RAW_EXPORTS_PRODUCT_ALIASES,
  ORDERS_BY_LOT,
  RAW_EXPORTS_SHIPPED_ITEMS,
  PRODUCT_SALES,
  SHIPMENT_COUNT_BY_USER,
  INVENTORY_LOW_STOCK_REPORT,
  INVENTORY_STATUS_REPORT,
  INVENTORY_OUT_OF_STOCK_SHIPMENTS,
  INVENTORY_AUDIT_REPORT,
  SHIPPING_COST,
  ACCOUNT_BALANCE_HISTORY,
  SHIPPING_MANIFEST,
  HOTKEYS_REFERENCE_REPORT,
  BARCODE_SCAN_ACTION_REPORT,
  BARCODE_SCAN_QUICK_REFERENCE_REPORT,
  BILLING_REPORTS,
} from '../../constants';
import {
  PARAMETER_NAME_EMBED_IMAGES,
  PARAMETER_NAME_STATUS_ID,
  PARAMETER_NAME_STORE_GUID,
  PARAMETER_NAME_SAVED_FILTER_ID,
  PARAMETER_NAME_ITEM_DEMAND_GROUP_BY,
  PARAMETER_NAME_ITEM_DEMAND_SORT_BY,
  PARAMETER_NAME_SHOW_PRODUCT_SALES_BY,
  PARAMETER_NAME_USER,
  PARAMETER_NAME_SHIPMENT_GOUNT_BY_USER_GROUP_BY,
  PARAMETER_NAME_INVENTORY_WAREHOUSE_ID,
  PARAMETER_NAME_GROUP_BY_PARENT_SKU,
  PARAMETER_NAME_SPECIFIC_SKU,
  PARAMETER_NAME_SHOW_PRODUCT_ALIASES_BY,
  PARAMETER_NAME_SHOW_SHIPPED_ITEMS_BY,
  PARAMETER_NAME_LABEL_PROVIDER_ID,
  PARAMETER_NAME_SELLER_LABEL_PROVIDER_ID,
  PARAMETER_NAME_SHIPPING_SERVICE_ID,
  PARAMETER_NAME_SHOW_ACCOUNT_BALANCE_BY,
  PARAMETER_NAME_WAREHOUSE_ID,
  PARAMETER_NAME_SHIP_DATE,
  PARAMETER_NAME_HOTKEYS_REPORT_TYPE,
  PARAMETER_NAME_SHOW_BARCODE_SCAN_ACTION_BY,
  PARAMETER_NAME_SHOW_BARCODE_SCAN_ACTION_HOTKEYS,
  PARAMETER_NAME_LOT,
  PARAMETER_NAME_INVOICE_ID,
} from '../report-filters/report-parameter-names';

/**
 * Parse comma-separated invoice IDs into an array of trimmed strings
 * @param {string} invoiceIdString - Comma-separated invoice IDs (e.g., "123, 456, 789")
 * @returns {string[]} Array of invoice ID strings (e.g., ["123", "456", "789"])
 */
const parseInvoiceIds = (invoiceIdString) => {
  if (!invoiceIdString || typeof invoiceIdString !== 'string') {
    return [];
  }

  return invoiceIdString
    .split(',')
    .map((id) => id.trim())
    .filter(Boolean);
};

export const requestParametersFromReportParameters = (params) => {
  const {
    [PARAMETER_NAME_EMBED_IMAGES]: showImage,
    [PARAMETER_NAME_STATUS_ID]: statusID,
    [PARAMETER_NAME_STORE_GUID]: storeGuid,
    [PARAMETER_NAME_SAVED_FILTER_ID]: filterId,
    [PARAMETER_NAME_ITEM_DEMAND_GROUP_BY]: groupBy,
    [PARAMETER_NAME_ITEM_DEMAND_SORT_BY]: sortBy,
    [PARAMETER_NAME_SHOW_PRODUCT_SALES_BY]: showProductSalesBy,
    [PARAMETER_NAME_USER]: userGuid,
    [PARAMETER_NAME_SHIPMENT_GOUNT_BY_USER_GROUP_BY]: shipmentCountGroupBy,
    [PARAMETER_NAME_INVENTORY_WAREHOUSE_ID]: inventoryWarehouseId,
    [PARAMETER_NAME_GROUP_BY_PARENT_SKU]: groupByParentSku,
    [PARAMETER_NAME_SPECIFIC_SKU]: specificSku,
    [PARAMETER_NAME_SHOW_PRODUCT_ALIASES_BY]: showProductAliasesBy,
    [PARAMETER_NAME_SHOW_SHIPPED_ITEMS_BY]: showShippedItemsBy,
    [PARAMETER_NAME_LABEL_PROVIDER_ID]: labelproviderId,
    [PARAMETER_NAME_SELLER_LABEL_PROVIDER_ID]: sellerLabelProviderId,
    [PARAMETER_NAME_SHIPPING_SERVICE_ID]: serviceId,
    [PARAMETER_NAME_SHOW_ACCOUNT_BALANCE_BY]: showAccountBalanceBy,
    [PARAMETER_NAME_WAREHOUSE_ID]: warehouseId,
    [PARAMETER_NAME_SHIP_DATE]: shipDate,
    [PARAMETER_NAME_HOTKEYS_REPORT_TYPE]: hotkeysReportType,
    [PARAMETER_NAME_SHOW_BARCODE_SCAN_ACTION_BY]: barcodeScanActionType,
    [PARAMETER_NAME_SHOW_BARCODE_SCAN_ACTION_HOTKEYS]: shouldShowHotkeys,
    [PARAMETER_NAME_LOT]: lot,
    [PARAMETER_NAME_INVOICE_ID]: invoiceId,
    requestBody,
    page,
  } = params;
  const requestGeneratorMap = {
    [ORDER_DETAIL]: () => ({
      ...requestBody,
      storeGuid,
      showImage,
    }),

    [COUNTRY_COMPARISON]: () => ({
      ...requestBody,
      embedImages: true,
    }),
    [BUYER_COMMENTS]: () => ({
      ...requestBody,
      statusID,
    }),
    [ITEM_DEMAND_SUMMARY]: () => ({
      ...requestBody,
      [PARAMETER_NAME_STATUS_ID]: statusID,
      [PARAMETER_NAME_ITEM_DEMAND_GROUP_BY]: groupBy,
      [PARAMETER_NAME_ITEM_DEMAND_SORT_BY]: sortBy,
      [PARAMETER_NAME_SAVED_FILTER_ID]: filterId,
    }),
    [RETURNED_PRODUCTS]: () => ({
      ...requestBody,
    }),
    [BATCH_DETAIL]: () => ({
      ...requestBody,
    }),
    [SHIPMENTS_SHIPPED_ITEMS]: () => ({
      ...requestBody,
      [PARAMETER_NAME_STORE_GUID]: storeGuid,
    }),
    [RAW_EXPORTS_CUSTOMERS]: () => ({
      ...requestBody,
    }),
    [RAW_EXPORTS_ORDERS]: () => ({
      ...requestBody,
      [PARAMETER_NAME_STORE_GUID]: storeGuid,
    }),
    [RAW_EXPORTS_SHIPPED_ORDERS]: () => ({
      ...requestBody,
      [PARAMETER_NAME_STORE_GUID]: storeGuid,
    }),
    [PRODUCT_SALES]: () => ({
      ...requestBody,
      [PARAMETER_NAME_STORE_GUID]: storeGuid,
      [PARAMETER_NAME_SHOW_PRODUCT_SALES_BY]: showProductSalesBy,
    }),
    [SHIPMENT_COUNT_BY_USER]: () => ({
      ...requestBody,
      [PARAMETER_NAME_SHIPMENT_GOUNT_BY_USER_GROUP_BY]: shipmentCountGroupBy,
      [PARAMETER_NAME_USER]: userGuid,
    }),
    [INVENTORY_LOW_STOCK_REPORT]: () => ({
      ...requestBody,
      [PARAMETER_NAME_INVENTORY_WAREHOUSE_ID]: inventoryWarehouseId,
      [PARAMETER_NAME_GROUP_BY_PARENT_SKU]: groupByParentSku,
    }),
    [INVENTORY_STATUS_REPORT]: () => ({
      ...requestBody,
      [PARAMETER_NAME_INVENTORY_WAREHOUSE_ID]: inventoryWarehouseId,
      [PARAMETER_NAME_GROUP_BY_PARENT_SKU]: groupByParentSku,
    }),
    [INVENTORY_OUT_OF_STOCK_SHIPMENTS]: () => ({
      ...requestBody,
      [PARAMETER_NAME_INVENTORY_WAREHOUSE_ID]: inventoryWarehouseId,
      [PARAMETER_NAME_SPECIFIC_SKU]: specificSku,
    }),
    [INVENTORY_AUDIT_REPORT]: () => ({
      ...requestBody,
      [PARAMETER_NAME_INVENTORY_WAREHOUSE_ID]: inventoryWarehouseId,
      [PARAMETER_NAME_SPECIFIC_SKU]: specificSku,
    }),
    [RAW_EXPORTS_PRODUCT_ALIASES]: () => ({
      ...requestBody,
      [PARAMETER_NAME_STORE_GUID]: storeGuid,
      [PARAMETER_NAME_SHOW_PRODUCT_ALIASES_BY]: showProductAliasesBy,
    }),
    [ORDERS_BY_LOT]: () => ({
      ...requestBody,
      [PARAMETER_NAME_LOT]: lot,
    }),
    [RAW_EXPORTS_SHIPPED_ITEMS]: () => ({
      ...requestBody,
      [PARAMETER_NAME_STORE_GUID]: storeGuid,
      [PARAMETER_NAME_SHOW_SHIPPED_ITEMS_BY]: showShippedItemsBy,
    }),
    [SHIPPING_COST]: () => ({
      ...requestBody,
      [PARAMETER_NAME_STORE_GUID]: storeGuid,
      [PARAMETER_NAME_LABEL_PROVIDER_ID]: labelproviderId,
      [PARAMETER_NAME_SELLER_LABEL_PROVIDER_ID]: sellerLabelProviderId,
      [PARAMETER_NAME_SHIPPING_SERVICE_ID]: serviceId,
    }),
    [ACCOUNT_BALANCE_HISTORY]: () => ({
      ...requestBody,
      [PARAMETER_NAME_LABEL_PROVIDER_ID]: labelproviderId,
      [PARAMETER_NAME_SELLER_LABEL_PROVIDER_ID]: sellerLabelProviderId,
      [PARAMETER_NAME_SHIPPING_SERVICE_ID]: serviceId,
      [PARAMETER_NAME_SHOW_ACCOUNT_BALANCE_BY]: showAccountBalanceBy,
    }),
    [SHIPPING_MANIFEST]: () => ({
      ...requestBody,
      [PARAMETER_NAME_SHIP_DATE]: shipDate,
      [PARAMETER_NAME_LABEL_PROVIDER_ID]: labelproviderId,
      [PARAMETER_NAME_SELLER_LABEL_PROVIDER_ID]: sellerLabelProviderId,
      [PARAMETER_NAME_WAREHOUSE_ID]: warehouseId,
    }),
    [HOTKEYS_REFERENCE_REPORT]: () => ({
      ...requestBody,
      [PARAMETER_NAME_HOTKEYS_REPORT_TYPE]: hotkeysReportType,
    }),
    [BARCODE_SCAN_ACTION_REPORT]: () => ({
      ...requestBody,
      [PARAMETER_NAME_SHOW_BARCODE_SCAN_ACTION_BY]: barcodeScanActionType,
      [PARAMETER_NAME_SHOW_BARCODE_SCAN_ACTION_HOTKEYS]: shouldShowHotkeys,
    }),
    [BARCODE_SCAN_QUICK_REFERENCE_REPORT]: () => ({
      ...requestBody,
    }),
    [BILLING_REPORTS]: () => {
      const hasInvoiceId = invoiceId && invoiceId.trim() !== '';
      return {
        reportType: 'BillingReport',
        reportName: 'BillingReport',
        format: requestBody.format === 'pdf' ? 'PDF' : requestBody.format?.toUpperCase() || 'PDF',
        invoiceId: parseInvoiceIds(invoiceId),
        startDate: hasInvoiceId ? null : requestBody.startDate,
        endDate: hasInvoiceId ? null : requestBody.endDate,
      };
    },
  };
  if (!requestGeneratorMap[page]) {
    throw new Error('Make sure to add this report to the requestGeneratorMap');
  }
  return requestGeneratorMap[page]();
};
